import * as React from 'react';
import { CompactTile } from 'ui';
import { TileProps } from 'ui/tile/tile';
import * as navigate from 'app/area/shared/navigation';

import styles from './connect-case-selector.scss';
import { CasePermissions } from 'app/types-shared';
import { MdOutlineArrowDownward, MdOutlineArrowUpward } from 'react-icons/md';
import { shouldNavigateToModal } from 'app/components/helpers';

export interface ConnectedCasesTileTranslations {
  textMoveUp: string;
  textMoveDown: string;
  textOpenBowtie: string;
  textOpenCase: string;
}

export interface ConnectedCasesTileProps {
  urlOpenNew?: boolean;
  params?: { dashboardType?: string; favouriteId?: string };
}

export interface ConnectedCasesTileProps extends TileProps, ConnectedCasesTileTranslations {
  enabledConnectionOperations: { moveUp: boolean; moveDown: boolean };
  moveConnectionUp: (steps: number) => void;
  moveConnectionDown: (steps: number) => void;

  entityId: number;
  maxSequence: number;
  connectionTypeId: number;
  connectedDrafts?: any[];
  permissions: CasePermissions;
}

export const ConnectedCasesTile: React.FC<ConnectedCasesTileProps> = (props) => {

  const moveConnectionUp = () => props.moveConnectionUp(1);
  const moveConnectionDown = () => props.moveConnectionDown(1);

  const openBowtie = () => {
    const { primaryKey } = props;
    navigate.toBowtie(primaryKey.value, true);
  };

  const openCase = () => {
    const { primaryKey, urlOpenNew, params } = props;
    if (urlOpenNew) {
      navigate.toCaseView(primaryKey.value, false, true);
    } else {
      if(shouldNavigateToModal(!!params?.favouriteId, !!params?.dashboardType)) {
        navigate.toCaseViewModal(primaryKey.value, undefined, undefined, true);
      }
      else {
        navigate.toCaseView(primaryKey.value);
      }
    }
  };

  const { textMoveUp, textMoveDown, enabledConnectionOperations, enabledChildEntityOperations, 
    textOpenBowtie, textOpenCase, permissions, ...restProps } = props;

  const sequenceContextMenuOperations = [];
  sequenceContextMenuOperations.push({ text: textOpenCase, callback: openCase, icon: undefined });
  permissions && permissions.bowtie &&
    sequenceContextMenuOperations.push({ text: textOpenBowtie, callback: openBowtie, icon: undefined });
  enabledConnectionOperations && enabledConnectionOperations.moveUp &&
    sequenceContextMenuOperations.push({ text: textMoveUp, callback: moveConnectionUp, icon: <MdOutlineArrowUpward/> });
  enabledConnectionOperations && enabledConnectionOperations.moveDown &&
    sequenceContextMenuOperations.push({ text: textMoveDown, callback: moveConnectionDown, icon: <MdOutlineArrowDownward/> });    

  return <>
    <CompactTile
      {...restProps}
      className={styles.connectedCaseTile}
      extendedContextMenuOperations={sequenceContextMenuOperations}
      enabledChildEntityOperations={{ ...enabledChildEntityOperations, ...{ add: false } }} />
  </>;
};
